import { TxnCategories } from "./books";
import { FileObject } from "./fileObject";

// Base status constants shared between individual items and CSV uploads
export const BASE_STATUS = {
  REQUESTED: "REQUESTED",
  SUBMITTED: "SUBMITTED",
} as const;

export type BaseStatus = (typeof BASE_STATUS)[keyof typeof BASE_STATUS];

// Individual open item status (inherits from base status)
export const ITEM_STATUS = BASE_STATUS;
export type ItemStatus = BaseStatus;

// CSV upload status (extends base status with additional states)
export const OPEN_ITEM_STATUS = {
  ...BASE_STATUS,
  ARCHIVED: "ARCHIVED",
  COMPLETED: "COMPLETED",
} as const;

export type OpenItemStatus =
  (typeof OPEN_ITEM_STATUS)[keyof typeof OPEN_ITEM_STATUS];

export type OpenItem = {
  uuid: string;
  csv_id: string;
  message_id: null | string;
  date?: string;
  description?: string;
  bank_name?: string;
  amount?: string;
  information_request?: string;
  clarification?: string;
  remarks?: string;
  invoice?: FileObject;
  merchant: string | null;
  logo: string | null;
  from: {
    bank_account: {
      uuid: string;
      nickname: string;
      mask: string;
      bank_brand: {
        name: string;
        logo_url: string;
      };
    };
    source:
      | "JOURNAL_ENTRY"
      | "PLAID"
      | "BANK_STATEMENT"
      | "DIRECT_CONNECT"
      | "LEDGER_ENTRY";
  };
  transaction_id?: string;
  transaction_category: TxnCategories | null;
  status: ItemStatus;
};

export type UploadCSV = {
  csv_id: string;
  message_id: null | string;
  status: OpenItemStatus;
  open_items: OpenItem[];
  entity_id?: string;
};
